export default function getSrcSet(url: string, sizes: Array<Array<number>>): string {
	let result = '';
	sizes.forEach((size) => {
		result += `${url.replace('{width}', size[0].toString())} ${size[1]}w,`;
	});
	return result.slice(0, -1);
}
